export function randomRangeInt(min: number, max: number) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function convertHexToRGBA(hex: string, opacity: number = 1) {
	if (opacity > 1 || opacity < 0) {
		throw new Error("opacity must be between 0 and 1");
	}

	let tempHex = hex.replace("#", "");
	if (tempHex.length === 3) {
		tempHex += tempHex;
	}
	const r = parseInt(tempHex.substring(0, 2), 16);
	const g = parseInt(tempHex.substring(2, 4), 16);
	const b = parseInt(tempHex.substring(4, 6), 16);

	return `rgba(${r},${g},${b},${opacity})`;
}

export function sleep(seconds: number) {
	return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
}

/**
 * Download file from given blob
 */
export function downloadFile(blob: Blob, filename: string) {
	const url = window.URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.style.display = "none";
	a.href = url;

	a.download = filename;
	document.body.appendChild(a);
	a.click();
	window.URL.revokeObjectURL(url);
}

export function getMimeTypeOfBlob(blob: Blob): Promise<string> {
	const fileReader = new FileReader();
	return new Promise<string>((resolve, reject) => {
		fileReader.onloadend = function (e) {
			if (e.target?.readyState === FileReader.DONE) {
				const uint = new Uint8Array(e.target.result as ArrayBuffer).subarray(0, 4);
				let bytes: string[] = [];
				uint.forEach((byte) => {
					bytes.push(byte.toString(16));
				});
				const hex = bytes.join("").toUpperCase();
				let mimeType;
				switch (hex) {
					case "89504E47":
						mimeType = "image/png";
						break;
					case "47494638":
						mimeType = "image/gif";
						break;
					case "FFD8FFDB":
					case "FFD8FFE0":
					case "FFD8FFE1":
						mimeType = "image/jpeg";
						break;
					// pdf
					case "25504446":
						mimeType = "application/pdf";
						break;
					default:
						mimeType = "unknown";
						break;
				}
				resolve(mimeType);
			}
		};
		fileReader.readAsArrayBuffer(blob);
	});
}

export const debounce = (func: (...args: any[]) => void, wait: number) => {
	let timeout: number;
	return (...args: any[]) => {
		window.clearTimeout(timeout);
		timeout = window.setTimeout(() => func(...args), wait);
	};
};
